import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export type OutstandingPayments = {
  count: number;
  total_owed_to_sidekick: number;
};

export function useOutstandingPayments(uid: string | undefined) {
  return useQuery<OutstandingPayments | null, Error>({
    queryKey: ["outstanding_payments", uid],
    enabled: !!uid,
    queryFn: async () => {
      if (!uid) return null;
      const res = await apiRequest("GET", `/billing_records/${uid}/outstanding`);
      return res.json();
    },
  });
}
